import React from "react";
import Table from "../../Common/Table";
import TableFields from "../../../constants/IssueType/TableFields.json";
import { Pill, FlexContainer } from "../../../constants/assets/containers";
import styled from "styled-components";
import ChevronDown from "sushiweb/Icons/all/ChevronDown";
import variables from "../../../constants/assets/variables";
import IssueTypeActionBar from "./IssueTypeActionBar";
import ConfirmationModal from "../../../components/Common/ConfirmationModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as IssueTypesActions from "../../../store/actions/IssueTypes";

const IssueTypeList = (props) => {
  const {
    issueTypeList,
    currentPage,
    saveUpdateIssueType,
    getIssueTypeList,
    activeFilters,
  } = props;
  const [showActionType, setShowActionType] = React.useState(false);
  const [activeIssueId, setActiveIssueId] = React.useState();
  const [activeIssueTypeEnabled, setActiveIssueTypeEnabled] = React.useState();
  const [showConfirmationModal, setShowConfirmationModal] =
    React.useState(false);
  const [actionCoord, setActionCoord] = React.useState({
    top: "",
    right: "",
  });

  const handleBlur = () => {
    setShowActionType(false);
  };
  const handleAction = (action_id, issueId, enabled) => {
    setShowActionType(true);
    const activeAct = document.getElementById(`${action_id}`);
    setActiveIssueId(issueId);
    setActiveIssueTypeEnabled(enabled);
    if (activeAct) {
      setActionCoord({
        top: activeAct.getBoundingClientRect().top + 10,
        right: window.innerWidth - activeAct.getBoundingClientRect().right,
      });
      activeAct.style.zIndex = 200;
    }
  };
  const openEnableDisableModal = () => {
    setShowConfirmationModal(true);
  };
  const closeEnableDisableModal = () => {
    setShowConfirmationModal(false);
  };

  const handleEnableDisable = (type, issueId) => {
    const issueTypeData = issueTypeList.find((item) => item.id === issueId);

    if (issueTypeData) {
      const completeObj = {
        ...issueTypeData,
        conditionsV2: transformConditionsToV2(issueTypeData.conditionsV2 || []),
        enabled: !type,
        dontUpdateVernacularTranslations: true,
      };

      saveUpdateIssueType("edit", completeObj)
        .then((res) => {
          getIssueTypeList(currentPage, activeFilters);
          closeEnableDisableModal();
        })
        .catch((err) => {
          console.error("Error updating issue type:", err);
          closeEnableDisableModal();
        });
    }
  };

  const transformConditionsToV2 = (conditions) => {
    if (!Array.isArray(conditions) || conditions.length === 0) {
      return [];
    }

    const conditionsV2 = [];

    conditions.forEach((condition) => {
      if (
        !condition.hasOwnProperty("key") &&
        !condition.hasOwnProperty("value")
      ) {
        const key = Object.keys(condition)[0];
        if (key && key.trim() !== "") {
          conditionsV2.push(condition);
        }
        return;
      }

      const { key, value } = condition;

      if (!key || key.trim() === "") {
        return;
      }

      const conditionObj = {};
      conditionObj[key] = value;
      conditionsV2.push(conditionObj);
    });

    return conditionsV2;
  };

  const getFieldValue = (issueType, key, index) => {
    switch (key) {
      case "id":
        return issueType.cartheroRefId ? issueType.cartheroRefId : "-";
      case "enabled":
        return (
          <div className="flex items-center justify-center">
            <Pill isFalse={!issueType[key]}>
              {issueType[key] ? "Yes" : "No"}
            </Pill>
          </div>
        );
      case "action":
        return (
          <FlexContainer
            justify="flex-start"
            onClick={() => {
              handleAction(`actions_${index}`, issueType.id, issueType.enabled);
            }}
            className={"edit-options cursor-pointer actions-holder"}
            id={`actions_${index}`}
          >
            <span>Actions</span> <ChevronDown color={variables.primaryColor} />{" "}
          </FlexContainer>
        );
      case "conditions":
        return issueType.conditionsV2 && issueType.conditionsV2.length
          ? JSON.stringify(issueType.conditionsV2)
          : "-";
      default:
        return issueType[key] ? issueType[key] : "-";
    }
  };
  return (
    <IssueTypeListContainer>
      <Table
        list={issueTypeList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      <ConfirmationModal
        open={showConfirmationModal}
        modalTitle={`${
          activeIssueTypeEnabled ? "Disable" : "Enable"
        } Issue Type`}
        onCofirmCancelHandler={closeEnableDisableModal}
        onCofirmSuccessHandler={() =>
          handleEnableDisable(activeIssueTypeEnabled, activeIssueId)
        }
        successButtonText={activeIssueTypeEnabled ? "Disable" : "Enable"}
        CancelButtonText={"Cancel"}
      >
        <p>
          Are you sure you want to{" "}
          {activeIssueTypeEnabled ? "Disable" : "Enable"} the issue type?
        </p>
      </ConfirmationModal>
      {showActionType && (
        <IssueTypeActionBar
          handleBlur={handleBlur}
          top={actionCoord.top}
          right={actionCoord.right}
          issueId={activeIssueId}
          enabled={activeIssueTypeEnabled}
          openEnableDisableModal={openEnableDisableModal}
        />
      )}
    </IssueTypeListContainer>
  );
};
const IssueTypeListContainer = styled.div`
  height: calc(100vh - 215px);
`;
const mapStateToProps = (state) => {
  const { SubIssueTypes, IssueTypes } = state;
  return {
    subIssueTypeDetails: SubIssueTypes.subIssueTypeDetails,
    remoteSearch: IssueTypes.remoteSearch,
    issueTypeList: IssueTypes.issueTypeList,
    currentPage: SubIssueTypes.currentPage,
    activeFilters: SubIssueTypes.activeFilters,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    getIssueTypeList: bindActionCreators(
      IssueTypesActions.getIssueTypeList,
      dispatch
    ),
    saveUpdateIssueType: bindActionCreators(
      IssueTypesActions.saveUpdateIssueType,
      dispatch
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(IssueTypeList);
